import { GetterTree } from 'vuex';
import { EImportStep } from '@/dealroom/add-page/import-progress/types/enums/import-step';
import { EImportProgressGetter } from '@/dealroom/add-page/import-progress/store/import-progress.constants';
import { IImportProgressState } from '@/dealroom/add-page/import-progress/store/import-progress.types';
import { RootState } from '@/store/store';

export const getters: GetterTree<IImportProgressState, RootState> = {
  [EImportProgressGetter.ImportCompleted](state: IImportProgressState): boolean {
    if (state.error) {
      return false;
    }
    return state.progress.currentStep === EImportStep.Done;
  },
};
